import React from "react";

import snakeToPascal from "../../../../../lib/snakeToPascal";
import * as Renderers from "./FrontEndRenderers/";

const resolveRenderer = ({ attributeName, rendererName }) => {
  if (typeof attributeName !== "string") {
    return null;
  }

  const finalRendererName = snakeToPascal(rendererName || attributeName);

  return Renderers[finalRendererName] ?? null;
};

const GeneratedInFrontEnd = props => {
  const Renderer = resolveRenderer(props);

  if (!Renderer) {
    return null;
  }

  return (
    <div className="generated-in-front-end-renderer">
      <Renderer {...props} />
    </div>
  );
};

GeneratedInFrontEnd.shouldRenderDash = props => {
  const Renderer = resolveRenderer(props);

  return typeof Renderer?.shouldRenderDash === "function"
    ? Renderer.shouldRenderDash(props)
    : undefined;
};

export default GeneratedInFrontEnd;
